import { gql } from "@apollo/client";
import { RENTAL_HISTORY_FIELDS } from "./query";

const CREATE_RENTAL_HISTORY = gql`
  mutation createRentalHistory($input: CreateRentalHistoryInput!) {
    createRentalHistory(input: $input) {
      rentalHistory {
        ${RENTAL_HISTORY_FIELDS}
      }
    }
  }
`;

const UPDATE_RENTAL_HISTORY = gql`
  mutation updateRentalHistory($input: UpdateRentalHistoryInput!) {
    updateRentalHistory(input: $input) {
      rentalHistory {
        ${RENTAL_HISTORY_FIELDS}
      }
    }
  }
`;

const DELETE_RENTAL_HISTORY = gql`
  mutation deleteRentalHistory($id: ID!) {
    deleteRentalHistory(id: $id) {
      id
    }
  }
`;

export {
  CREATE_RENTAL_HISTORY,
  UPDATE_RENTAL_HISTORY,
  DELETE_RENTAL_HISTORY,
};
